export default "__VITE_ASSET__BKyLVn4O__"